var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_56)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#6B024D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.716 16.777L11.744 25.72C11.35 26.11 10.71 26.11 10.315 25.72C9.92 25.33 9.92 24.69 10.315 24.29L18.624 16.016L10.315 7.73602C9.92 7.34402 9.92 6.70699 10.315 6.31299C10.71 5.92099 11.35 5.92099 11.744 6.31299L20.716 15.254C20.927 15.464 21.017 15.741 21.002 16.016C21.017 16.29 20.927 16.568 20.716 16.777ZM28 0H4C1.791 0 0 1.791 0 4V28C0 30.21 1.791 32 4 32H28C30.209 32 32 30.21 32 28V4C32 1.791 30.209 0 28 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoArrow);
export default __webpack_public_path__ + "static/media/go_arrow.c5a57d6ab24e3e6b439f985a7758406a.svg";
export { ForwardRef as ReactComponent };